<div class=" main-content">
  <app-dashboard-side-menu></app-dashboard-side-menu>
  <div class="d-flex flex-column w-100">
    <app-dashboard-top-menu></app-dashboard-top-menu>

    <div class="d-flex flex-column m-4" style="padding: 0 100px 50px">

      <div class="row align-items-center">
        <a routerLink="/backoffice/comunicados">
          <button mat-icon-button>
            <mat-icon svgIcon="arrow_left_sm" class="h-auto w-auto"></mat-icon>
          </button>
        </a>
        <h2 class="m-0 p-0">{{ isAddMode ? "Novo Comunicado" : ''}}</h2>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <p>Tipo Utilizador <span>*</span> @if (form.get('type')?.invalid && submitted) {
            <span
            >Obrigatório.</span>
          }</p>
          <mat-form-field>
            <mat-select formControlName="type">
              <mat-option value="P">P (PetVet)</mat-option>
              <mat-option value="C">C (Cliente)</mat-option>
              <mat-option value="L">L (Laboratorio)</mat-option>
              <mat-option value="CP">CP (Cliente e PetVet)</mat-option>
              <mat-option value="CPLV">CPLV (Todos)</mat-option>
              <mat-option value="V">V (VetFamily)</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-6 col-xs-12">
          <p>Permanente<span>*</span> @if (form.get('isPermanent')?.invalid && submitted) {
          <span
          >Obrigatório.</span>
        }</p>
        <mat-form-field>
          <mat-select formControlName="isPermanent">
            <mat-option [value]="true">Sim</mat-option>
            <mat-option [value]="false">Não</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-6 col-xs-12">
        <p>Data Início<span>*</span>
        @if (form.get('startingDate')?.invalid && submitted) {
          <span>Obrigatório. </span>
        }
        @if (!startDateValid && submitted) {
          <span>Não pode ser maior que a Data Fim.</span>
        }
      </p>
      <mat-form-field>
        <input matInput [matDatepicker]="pickerInicio" formControlName="startingDate">
        <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
        <mat-datepicker #pickerInicio></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-6 col-xs-12">
      <p>Data Fim<span>*</span>
      @if (form.get('endDate')?.invalid && submitted) {
        <span>Obrigatório. </span>
      }
      @if (!startDateValid && submitted) {
        <span>Não pode ser menor que a Data Início.</span>
      }
    </p>
    <mat-form-field>
      <input matInput [matDatepicker]="pickerFim" formControlName="endDate">
      <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
      <mat-datepicker #pickerFim></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="col-md-12 col-xs-12">
    @if (!comunicadoValid) {
      <p class="text-danger">{{comunicadoError}}</p>
    }
    <div class="NgxEditor__Wrapper">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
      <ngx-editor [editor]="editor" formControlName="description"
      placeholder="Comunicado..."></ngx-editor>
    </div>
  </div>
  <div class="col-md-6 col-xs-12">
    <p>
      Imagem do comunicado
    </p>
    <input type="file" [accept]="imgType" (change)="checkFileSize($event, 5)">
  </div>
  <div class="d-flex" style="align-self: center; width: 50%; justify-content: right;">
    <button mat-flat-button class="btn-green mr-3 float-right">
      {{isAddMode ? 'Adicionar Comunicado': 'Guardar Comunicado'}}
      <mat-icon svgIcon="check" class="h-auto" iconPositionEnd></mat-icon>
    </button>
  </div>

</div>
</form>

</div>
<app-footer></app-footer>
</div>
</div>